import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectBetPositionErrorCode, selectIsServicePositionAvailable } from '../../../../selectors/betPosition';
import { ServicePositionError } from './ServicePositionError';
import { renderErrorMessage } from './renderErrorMessage';

export const ServicePositionErrorContainer = () => {
  const errorCode = useSelector(selectBetPositionErrorCode);
  const isServicePositionAvailable = useSelector(selectIsServicePositionAvailable);
  const message = renderErrorMessage(errorCode);

  if (isServicePositionAvailable && message) {
    return <ServicePositionError message={message} />;
  }

  return null;
};
